export default {
    fiscalYears: [],
    monthYearAvailablities: [],
    loading: false,
}
